module.exports = __webpack_public_path__ + "static/media/LA.3d622932.svg";